import babelpolyfill from 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'default-passive-events'
import 'element-ui/lib/theme-chalk/index.css'
import './common/css/common.css'
import util from './common/js/util'
import UploadServer from './common/js/upload'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import routes from './routes'
import curlApi from './api/api'
import config from './api/config'
// import Mock from './mock'
// Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'
import './styles/style.css'

// 时间过滤器
import Moment from 'moment'
Vue.prototype.$moment = Moment;


import {IconPark} from '@icon-park/vue/es/all';
Vue.component('IconPark', IconPark);
import VueCookies from 'vue-cookies';
import md5 from 'md5';
import UUID from 'vue-uuid'

const BrowerLogger = require('alife-logger');
const __bl = BrowerLogger.singleton({pid:"cvgcra4c7j@3b67a6197cc3998",appType:"web",imgUrl:"https://arms-retcode.aliyuncs.com/r.png?",sendResource:true,enableLinkTrace:true,behavior:true});


Vue.use(UUID)
Vue.use(ElementUI)
Vue.use(util)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueCookies)
Vue.use(md5)
Vue.use(UploadServer)

import { currencyFilters } from './api/common'
Vue.filter('currencyFilters',currencyFilters);

import pagination from './components/common/tablePagination.vue'
Vue.component('pagination', pagination);
// import SIdentify from './components/common/identify'
// Vue.use(SIdentify)
if(false === Vue.prototype.$cookies.isKey('_x_uuid'))
{
	Vue.prototype.$cookies.set('_x_uuid', md5(Vue.prototype.$uuid.v4()), )
}

const router = new VueRouter({
  mode: "history",
  routes
})

Vue.use(curlApi, router);
Vue.prototype.$config = config;

//菜单权限配置
router.beforeEach((to, from, next) => {
		if(to.path == '/regs' | to.path == '/forget'){
			next()
			return;
		}
		if (to.path == '/login') {
			localStorage.removeItem('tokenInfo');
			next();
		}
		if(to.name == 'switch_system'){
			 next();
			 return;
		}

		let user = JSON.parse(localStorage.getItem('tokenInfo'));
        if (user && user['merchant_role']) {
			for (let i=0;i < routes.length;i++) {
				if (user['merchant_role'].indexOf(routes[i].id) != -1) {
					routes[i].hidden = false;
				}else{
					routes[i].hidden = true;
				}
				if (routes[i].children) {
					for (let j=0;j < routes[i].children.length;j++) {
						if (user['merchant_role'].indexOf(routes[i].children[j].id) != -1) {
							routes[i].children[j].hidden = false;
						}else{
							routes[i].children[j].hidden = true;
						}
					}
				}
			  }
        }
		if (!user && to.path != '/login') {
				next({ path: '/login'})
		} else {
			var merchant_user_name_list = ['select','industry','create','successful'];
			if(merchant_user_name_list.indexOf(to.name) !== -1){   //退出当前店铺
					user.x_account_type = 'merchant_user';
					user.merchant_role = '';
					localStorage.setItem('tokenInfo',JSON.stringify(user));
					next()
			}else{
				if(user && user.x_account_type !== 'merchant'){
					next({ path:'/select'});
				}else{
					next();
				}
			}
		}
})


//router.afterEach(transition => {
//NProgress.done();
//});

new Vue({
  router,
  store,
  // components: { App }
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js